import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { TimeEntry } from '../state-man/models/time-entry.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class TimeEntryService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getMine () : Promise<TimeEntry[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'time_entry/mine/')             
      const time_entries = (ret && Array.isArray(ret)) ? TimeEntry.buildMany(ret) : null

      if (!time_entries) return null
      return time_entries      
    } catch (error) {
      LoggerService.log(error + 'time_entry/mine')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  


  public async addTimeEntry(time_entry: TimeEntry) : Promise<TimeEntry | null> {
    try {
      const body = time_entry
      const obj = await this.apiService.apiReturnsAny('post', 'time_entry/', body, 'application/json')    
      return obj
    } catch (error) {
      LoggerService.log(error + 'post time_entry/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }   

  public async updateTimeEntry(time_entry: TimeEntry) : Promise<TimeEntry | null> {
    try {          
      const body = time_entry
      const obj = await this.apiService.apiReturnsAny('put', 'time_entry/' + time_entry.id, body, 'application/json')         
      return obj      
    } catch (error) {
      LoggerService.log(error + 'put time_entry/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }

  public async deleteTimeEntry(time_entry: TimeEntry) : Promise<any> {
    try {
      const ret = await this.apiService.apiReturnsAny('delete', 'time_entry/' + time_entry.id)               
      return ret
    } catch (error) {
      LoggerService.log(error + 'delete time_entry/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  
}
